import { ClienteUnidadeNegocioSearchMercado } from './mercado';

export class ClienteUnidadeNegocioSearch {
    id: number;
    createdAt: Date;
    idUnidadeNegocio: number;
    nomeUnidadeNegocio: string;

    /** Configurações */
    // Pedidos
    /** Se a unidade de negócio deve habilitar a possibilidade de informar os comprimentos dos itens nos pedidos e cotações */
    habilitarComprimentosItensPedidos: boolean;

    mercados: ClienteUnidadeNegocioSearchMercado[];

    constructor() {
        this.mercados = [];
    }
}
